/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
import React, { Component } from 'react'

export default class LoadingMessage extends Component {

    render() {
        return (
            <h3 className="LoadingMessage">
                <i className="trace-icon loading-ball-gray" />
                <span>Loading</span>
            </h3>
        )
    }

}
